const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMmEyIDIgMCAwIDEgMiAydjEyYTIgMiAwIDAgMS0yIDJoLTcuOTEzTDYgMjEuODA0VjE4SDRhMiAyIDAgMCAxLTItMlY0YTIgMiAwIDAgMSAyLTJoMTZ6bTAgMkg0djEyaDR2Mi4xOTZMMTEuNTEzIDE2SDIwVjR6bS02IDd2Mkg3di0yaDd6bTItNHYySDdWN2g5eiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=message-8743df7c.mjs.map
